export const bscMainnetAddresses = {
  TRAVA_TOKEN_ADDRESS: "0x0391bE54E72F7e001f6BBc331777710b4f2999Ef",
  RENT_CONTRACT_ADDRESS: "0xEC04d3aDaFD3A352A8F8A836Dc6e62d94b7655Cd",
  KAWAII_CORE_ADDRESS: "0x527A7ec10Ef231ABB63b3d40F3f2dE8AC67c60f5",
  KAWAII_PROXY_CONTRACT_ADDRESS: "0xDA02dffBf90807d43E14aaDA8D6DaD931bc44c90",
  MULTI_CALL_ADDRESS: "0x956BBC80253755A48FBcCC6783BBB418C793A257",
  TOKEN_FAUCET_ADDRESS: "0xbf56d82d4C5f58ebd9eeAA74a77B8b52D154351F",
  TRAVA_AIRDROP_ADDRESS: "0x81d19c26A9Df9D65691C329C435B9e76fe40573d",
  KAWAII_AIRDROP_ADDRESS: "0x710443C07311E05F81E56D7caD26188ccc26E7C6",
  KAWAII_TOKEN_ADDRESS: "0x257a8d1E03D17B8535a182301f15290F11674b53",

  NFT_CORE_ADDRESS: "0xAcBfD38C52Ae0344D47A7335D072DE5e3BC49f91",
  NFT_MANAGER_ADDRESS: "0xDE4e584DA24e9a528eCb3ffD0AaccBAEe2EfD137",
  NFT_COLLECTION_ADDRESS: "0x9C3E857eCe6224544aA77c1A6e500d8Fa1c9C102",
  NFT_SELL_ADDRESS: "0x39728bB898f6e44D0c0EC9d7934976e5ceA4DcAf",
  NFT_BUY_ADDRESS: "0xeD943988b57195A6668a212b189A2e9f8c151A61",
  NFT_SELL_COLLECTION_ADDRESS: "0x78DA1F3A42a0C9Cd3448c81081E5266d4567B3Ff",
  GIVEAWAY_ADDRESS: "0xd750a6C07314222643a039E8857Ab0C79AeaBB33",
  NFT_TRANSMUTATION_ADDRESS: "0xaAe9d2058f7721c17E58cf1e70052b4D3A8A9308",
  NFT_AUCTION_ADDRESS: "0xAaA727635be13b6668Eb0068F53229689dBc7Af6",
};
